import { render, staticRenderFns } from "./ProjectDetail.vue?vue&type=template&id=16fa010e"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetail.vue?vue&type=style&index=0&id=16fa010e&prod&lang=scss"
import style1 from "./ProjectDetail.vue?vue&type=style&index=1&id=16fa010e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports